<div class="input-container">
    <input class="rounded-input" *ngIf="formControl" [formControl]="formControl" [name]="name" [matAutocomplete]="autocomplete" [placeholder]="placeholder" (focus)="onFocus($event)" (blur)="onBlur($event)" (keydown.enter)="onEnter($event)" #autocompleteInput
    />
    <input class="rounded-input" *ngIf="!formControl" [name]="name" [matAutocomplete]="autocomplete" [placeholder]="placeholder" (focus)="onFocus($event)" (blur)="onBlur($event)" (keydown.enter)="onEnter($event)" #autocompleteInput />
    <button *ngIf="hasSearchButton" #searchButton mat-button matPrefix mat-icon-button aria-label="Search" (click)="search()" type="button">
      <mat-icon class="search-icon">search</mat-icon>
    </button>
    <!-- <button *ngIf="selectedOption || query" mat-button matSuffix mat-icon-button aria-label="Clear" (click)="clearValue()" #clearButton type="button">
        <mat-icon class="clear-icon">clear</mat-icon>
    </button> -->
    <mat-progress-bar mode="indeterminate" *ngIf="hasProgressBar && requestsInQueue > 0"></mat-progress-bar>
    <mat-autocomplete #autocomplete="matAutocomplete" [displayWith]="autocompleteDisplayFn()" (optionSelected)="autocompleteSelected($event)">
        <mat-option *ngFor="let item of autocompleteList" [value]="item">
            <ng-template [ngIf]="displayTemplate">
                <ng-container *ngTemplateOutlet="displayTemplate; context: {$implicit: item}"></ng-container>
            </ng-template>
            <span *ngIf="!displayTemplate">
        {{viewItem(item)}}
      </span>
        </mat-option>
        <mat-option *ngIf="query && noSuggestions" disabled>
            <span>No results</span>
        </mat-option>
        <mat-option *ngIf="query && noSuggestions && showAddNew" [value]="query" (click)="onCreateNew()">
            <!-- <mat-icon class="add-icon">add</mat-icon>  --><span class="create-new"> {{addNewText}} </span>
        </mat-option>
    </mat-autocomplete>
    <mat-error>
        {{ validationErrors && validationErrors.length > 0 ? validationErrors[0] : ''}}
    </mat-error>
</div>